import React, { useContext } from 'react';
import flush from 'just-flush';
import { FaLinkedinIn, FaRegEnvelope } from 'react-icons/fa';
import { TeamCardsSection } from '@stereoagency/ui';
import { LinesContext } from '@/components/LinesContext';
import { ILazyBlocksImage } from '@/types';
import { useMediaItems } from '@/hooks';

type Props = {
  data?: {
    label?: string
    title?: string;
    cards?: {
      card_image?: ILazyBlocksImage;
      card_name?: string;
      card_role?: string;
      card_description?: string;
      card_linkedin_url?: string;
      card_email?: string;
    }[];
  } | null
};

export default function NvisoTeamCardsSection({ data }: Props) {
  const { enableLines } = useContext(LinesContext);
  const mediaItems = useMediaItems(flush(data?.cards?.map((card) => card.card_image?.id) ?? []));
  if (!data?.title || !data.cards?.length) return null;

  return (
    <TeamCardsSection
      enableLines={enableLines}
      label={data.label}
      title={data.title}
      cards={flush(data.cards.map((card) => {
        const image = card.card_image?.id ? mediaItems.get(card.card_image.id) : null;
        if (!image || !card.card_name) return null;
        return {
          image: {
            src: image.mediaItemUrl ?? '',
            width: image.mediaDetails?.width ?? 1000,
            height: image.mediaDetails?.height ?? 1000,
          },
          name: card.card_name,
          subtitle: card.card_role,
          description: card.card_description,
          links: flush([
            card.card_linkedin_url ? {
              icon: <FaLinkedinIn />,
              href: card.card_linkedin_url,
              target: '_blank',
            } : null,
            card.card_email ? {
              icon: <FaRegEnvelope />,
              href: `mailto:${card.card_email}`,
              target: '_blank',
            } : null,
          ]),
        };
      }))}
    />
  );
}
